import axios from 'axios'

axios.interceptors.request.use(function (config) {
    if(config.baseURL.indexOf('http://47.94.145.146') !== -1) {
        let token = window.sessionStorage.getItem('token');
        if(token) {
            config.headers.token = token;
        }else{
            console.log('找不到token了，兄弟');
        }
    }
    // let astoken = 'DC1481494A6E6EF48F145B54542BDEC3';
    // config.headers.token = astoken;
    return config;
}, function (error) {
    console.log('拦截器出错了');
    return false;
})


axios.defaults.baseURL = 'http://47.94.145.146:8182/'

const http = {};

http.install = function (Vue, options) {
    Vue.prototype.$http = axios;
}

export default http;







// WEBPACK FOOTER //
// ./src/plugins/http.js